<template>
    <div id="manager">
        <b-navbar id="topnav" toggleable="lg" type="dark">
            <b-navbar-brand>
                <img id="oscar-logo" src="@/assets/oscar_logo_r.png" alt="Oscar" height="30"><span id="diili-title">&nbsp;Diili</span>
            </b-navbar-brand>
            <b-nav-text class="mx-3"><a href="tel:0108201010"><font-awesome-icon icon="phone" /> 010 820 1010</a></b-nav-text>
            <b-nav-text class="mx-3"><a href="mailto:info@oscar.fi"><font-awesome-icon icon="envelope" /> info@oscar.fi</a></b-nav-text>
            <b-nav-text class="mx-3 username">{{ username }}</b-nav-text>
            <b-nav-text class="mx-3 logout" @click="logout"><font-awesome-icon icon="sign-out-alt" /></b-nav-text>
        </b-navbar>

        <div class="row">
            <div id="manager-nav" class="col-md-2 col-xs-12">
                <b-nav vertical pills class="p-3">
                    <b-nav-item v-if="isAdmin" :to="{ name: 'managerConfiguration' }">
                        <font-awesome-icon icon="wrench" /> {{ $t("manager.configuration.title") | capitalize-first }}
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'managerCompanies' }">
                        <font-awesome-icon icon="building" /> {{ $t("manager.companies.title") | capitalize-first }}
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'offer-list' }">
                        <font-awesome-icon icon="list" /> {{ $t("manager.allOffers") }}
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'user-list' }">
                        <font-awesome-icon icon="users" /> {{ $t("manager.users.title") | capitalize-first }}
                    </b-nav-item>
                </b-nav>
            </div>
            <div id="manager-content" class="col-md-10 col-xs-12">
                <div class="p-3">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p class="m-2 text-white text-center">Oscar Diili {{ version | round-one-decimal }} &copy; Oscar Software Oy 2019</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Manager',
  data () {
    return {
    }
  },
  computed: {
    version () {
      return this.$store.getters.getAppInfo.version
    },
    username () {
      return this.$store.getters.getUser.username
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    }
  },
  created () {
    this.$store.dispatch('setTheme', {
      headerBgColor: '#1a1c28',
      headerFontColor: 'white'
    })
  }
}
</script>

<style lang="scss" scoped>
#manager {
    overflow-x: hidden;
    background-color: #1a1c28;

    #topnav {
        background-color: #1a1c28;

        .navbar-brand {
            height: 30px;
            display: inline-block;

            img {
                vertical-align: text-top;
            }
            span {
                display: inline-block;
                vertical-align: top;
                font-size: 30px;
                line-height: 30px;
                text-transform: uppercase;
                color: #ffa900;
                font-family: 'Exo', sans-serif;
            }
        }

        .navbar-text {
            color: #9fb1bb !important;

            a {
                color: #9fb1bb !important;

                &:hover {
                    color: #ffa900 !important;
                }
            }

            &.username {
                position:absolute;
                right: 40px;
            }
            &.logout {
                position:absolute;
                right: 0;

                &:hover {
                    color: #ffa900 !important;
                    cursor: pointer;
                }
            }
        }
    }

    #manager-nav {
        background-color: #222534;
        height: 100vh;

        .nav {
            .nav-item {
                .nav-link {
                    color: white !important;
                    border-radius: 0;

                    &.active, &:hover {
                        color: #ffa800 !important;
                        background-color: #1a1c28;
                    }
                }
            }
        }
    }

    #manager-content {
        background-color: white;
    }
}
</style>
